import React from 'react';
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  IconButton,
  Tooltip,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DownloadExcel from '../../../../images/download_excel.svg';
import NewReactTable from '../../../poc-shreecement/Ebitda/AISearch/NewReactTable/reactTable.jsx';

export { NewReactTable, NewReactTable as TableComponent };

export const DownloadExcelButton = ({
  onClick,
  disabled = false,
  loading = false,
  spinnerSize = 18,
}) => (
  <Box component="span" display="inline-flex" alignItems="center" gap={0.5}>
    <Tooltip title={loading ? 'Exporting...' : 'Export to Excel'}>
      <span>
        <IconButton
          size="small"
          onClick={onClick}
          disabled={disabled || loading}
          sx={{ p: 0.5 }}
        >
          <img src={DownloadExcel} alt="Export to Excel" width={28} height={28} />
        </IconButton>
      </span>
    </Tooltip>
    {loading && (
      <CircularProgress size={spinnerSize} sx={{ color: '#215093' }} />
    )}
  </Box>
);

export const Loader = ({ loading, children }) => (
  <>
    {loading && (
      <Box display="flex" justifyContent="center" py={2}>
        <CircularProgress size={24} />
      </Box>
    )}
    {!loading && children}
  </>
);

export const DrilldownDialog = ({
  open,
  onClose,
  children,
  paperSx = {},
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth={false}
    PaperProps={{
      sx: {
        width: '85vw',
        maxHeight: '80vh',
        ...paperSx,
      },
    }}
  >
    <DialogContent sx={{ p: 0, overflow: 'hidden' }}>{children}</DialogContent>
  </Dialog>
);

export const FullscreenModal = ({ open, onClose, title, children, actions }) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="xl">
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 2,
        py: 1.5,
        borderBottom: '1px solid #e0e0e0',
      }}
    >
      <Box component="span" sx={{ fontWeight: 600, color: '#215093' }}>
        {title}
      </Box>
      <Box display="flex" alignItems="center" gap={1}>
        {actions}
        <IconButton size="small" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
    </Box>
    <DialogContent>{children}</DialogContent>
  </Dialog>
);
